import { savedOrderListTableStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListTable";
import { css } from "styled-components";

savedOrderListTableStyles.orderDateCell = {
    css: css`
        font-weight: bold;
    `,
};
